import api from '../../store/config/api';
import { USER as SCHEMA } from '../../schemas';

export const [
  GET_USER,
  GET_USER_REQUEST,
  GET_USER_SUCCESS,
  GET_USER_FAILURE
] = api.buildTypes('GET_USER');

export function getUser({ teamName, username = 'me' }) {
  return {
    type: GET_USER,
    payload: {
      url: `/teams/${teamName}/users/${username}`,
      schema: SCHEMA
    }
  };
}

export const [
  UPDATE_USER,
  UPDATE_USER_REQUEST,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAILURE
] = api.buildTypes('UPDATE_USER');

export function updateUser({ teamName, userData, username = 'me' }) {
  return {
    type: UPDATE_USER,
    payload: {
      url: `/teams/${teamName}/users/${username}`,
      schema: SCHEMA,
      options: {
        method: 'PUT',
        body: userData
      }
    }
  };
}

export const [
  DELETE_USER,
  DELETE_USER_REQUEST,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAILURE
] = api.buildTypes('DELETE_USER');

export function deleteUser({ teamName, username = 'me' }) {
  return {
    type: DELETE_USER,
    payload: {
      url: `/teams/${teamName}/users/${username}`,
      schema: SCHEMA,
      options: {
        method: 'DELETE'
      }
    }
  };
}

export const [
  UNLOCK_USER,
  UNLOCK_USER_REQUEST,
  UNLOCK_USER_SUCCESS,
  UNLOCK_USER_FAILURE
] = api.buildTypes('UNLOCK_USER');

export function unlockUser({ teamName, username }) {
  return {
    type: UNLOCK_USER,
    payload: {
      url: `/teams/${teamName}/users/${username}/login-lock`,
      schema: SCHEMA,
      options: {
        method: 'DELETE'
      }
    }
  };
}



// WEBPACK FOOTER //
// ./js/actions/api/user.js